import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DroneSpecificationURL } from 'src/app/constants/url/droneSpecification.url';
import { ResponseDto } from 'src/app/dto/common/response.dto';
import { DroneSpecificationDto } from 'src/app/dto/droneSpecification/droneSpecification.dto';
import { FlightConfigurationDto } from 'src/app/dto/flightConfiguration/flightConfiguration.dto';
import { HttpService } from 'src/app/service/http/http.service';

@Component({
    selector: 'droneSpecifiation',
    templateUrl: '../../view/droneSpecification/droneSpecification.html'
})
export class DroneSpecificationComponent {
    public manufacturerList!: string[];
    public droneSpecList!: DroneSpecificationDto[];
    public flightConfigurationDto!: FlightConfigurationDto;

    @Output() public getChangeDroneEvent = new EventEmitter<DroneSpecificationDto>();

    constructor(private httpService: HttpService) { }

    public setSavedDrone(flightConfigurationDto: FlightConfigurationDto): void {
        if (!this.flightConfigurationDto) {
            this.flightConfigurationDto = Object.assign(new FlightConfigurationDto(), flightConfigurationDto);
            this.getManufacturerList();
        }
    }

    private getManufacturerList() {
        this.httpService.get<ResponseDto<string[]>>(DroneSpecificationURL.manufacturerList)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.manufacturerList = response.data;
                    this.getDroneList(this.flightConfigurationDto.manufacturer, true);
                }
            });
    }

    private getDroneList(manufacturerName: string, isFirst: boolean) {
        this.httpService.get<ResponseDto<DroneSpecificationDto[]>>(DroneSpecificationURL.droneList(manufacturerName))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.droneSpecList = response.data;

                    if (!isFirst) {
                        this.droneChange(this.droneSpecList[0]);
                    } else {
                        this.droneChange(this.getSelectedDrone());
                    }
                }
            });
    }

    public selectManufacturer(event: any): void {
        this.getDroneList(event.target.value, false);
    }

    public selectDrone(event: any): void {
        let index = parseInt(event.target.value);

        this.flightConfigurationDto.droneSpecSeq = this.droneSpecList[index].seq;
        this.flightConfigurationDto.name = this.droneSpecList[index].name;
        this.droneChange(this.droneSpecList[index]);
    }

    private getSelectedDrone(): DroneSpecificationDto {
        for (let i = 0; i < this.droneSpecList.length; i++) {
            if (this.flightConfigurationDto.droneSpecSeq == this.droneSpecList[i].seq) {
                return this.droneSpecList[i];
            }
        }

        return this.droneSpecList[0];
    }

    public droneChange(droneSpecifationDto: DroneSpecificationDto): void {
        this.flightConfigurationDto.droneSpecSeq = droneSpecifationDto.seq;
        this.flightConfigurationDto.name = droneSpecifationDto.name;

        this.getChangeDroneEvent.emit(droneSpecifationDto);
    }
}
